// extracted by mini-css-extract-plugin
export var component = "UpcomingEventParagraph-module--component--9ef7e";
export var fadePop = "UpcomingEventParagraph-module--fade-pop--794a9";
export var growHeightIn = "UpcomingEventParagraph-module--grow-height-in--ee6dd";
export var searchResultsPlaceholder = "UpcomingEventParagraph-module--searchResultsPlaceholder--62210";